$(window).on('load', function() {
	setTimeout(function() {
    	var metrics = window.performance;
    	if (metrics) {
            var timing = {};
            ["navigationStart", "unloadEventStart", "unloadEventEnd", "fetchStart", "domainLookupStart", "domainLookupEnd"
				, "connectStart", "connectEnd", "secureConnectionStart", "requestStart"
				, "responseStart", "responseEnd", "domLoading", "domInteractive", "domContentLoadedEventStart"
				, "domContentLoadedEventEnd", "domComplete", "loadEventStart", "loadEventEnd"
			].forEach(function (item) {
				timing[item] = metrics.timing[item];
            });

			timing["continent"] = continentCode;
			timing["pageType"] = parseInt(pageType);
			timing["pageTypeName"] = pageTypeName || "";
			timing["isBot"] = isBot ? 1 : 0;
			timing["isNewSession"] = isNewSession ? 1 : 0;
			timing["deviceType"] = deviceType;
			timing["uuid"] = viewUUID;
			var json = JSON.stringify(timing);

			var xhr = new XMLHttpRequest();
			xhr.open('POST', '/track-perf', true);
			xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
			xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
			xhr.send(json);
		}
	}, 1000);
});
